module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "homeWrap"
    }
  }, [(_vm.$parent.loadingIndicator) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "left": "0",
      "width": "100vw",
      "height": "100vh",
      "background": "rgba(0,0,0,0.7)",
      "z-index": "9999",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dash-wrap",
    class: {
      'shut': _vm.dashboardIsFolded
    }
  }, [_c('div', {
    staticClass: "dash-bg"
  }), _vm._v(" "), _c('Dashboard', {
    ref: "dashboard"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dashboardIsFolded),
      expression: "!dashboardIsFolded"
    }],
    attrs: {
      "id": "dashSmallDetails"
    }
  }, [_c('div', {
    attrs: {
      "data-html": "<img src='/static/dninfo.png' style='margin:-3px -5px -19px -5px'/>'",
      "data-variation": "inverted mini",
      "data-position": "top left"
    }
  }, [_vm._v("\n        Auto Refresh SentryKit Data: "), _c('span', {
    staticStyle: {
      "color": "#395"
    }
  }, [_vm._v("Always ON")]), _vm._v(" "), _c('br'), _vm._v("\n        Desktop Notifications:\n        "), (_vm.desktopNotifPerm == 'default') ? _c('span', {
    staticStyle: {
      "color": "#395"
    }
  }, [_vm._v("Browser Setting")]) : _vm._e(), _vm._v(" "), (_vm.desktopNotifPerm == 'granted') ? _c('span', {
    staticStyle: {
      "color": "#395"
    }
  }, [_vm._v("ON")]) : _vm._e(), _vm._v(" "), (_vm.desktopNotifPerm == 'denied') ? _c('span', {
    staticStyle: {
      "color": "#935"
    }
  }, [_vm._v("OFF")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "help circle icon"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [(_vm.$parent.worldStore.notifications) ? _c('NotificationReel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dashboardIsFolded),
      expression: "!dashboardIsFolded"
    }]
  }) : _vm._e()], 1), _vm._v(" "), _c('HelpMenu', {
    ref: "helpMenu"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "dash-scroll",
    attrs: {
      "href": "#"
    },
    on: {
      "click": [function($event) {
        if (!$event.shiftKey) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openHelpModal.apply(null, arguments)
      }, function($event) {
        $event.preventDefault();
        return _vm.toggleDashboard.apply(null, arguments)
      }]
    }
  }, [_c('span'), _vm._v(_vm._s(_vm._f("translate")('Scroll')))])], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dashboardIsFolded),
      expression: "dashboardIsFolded"
    }],
    staticClass: "ui tiny basic circular icon button hideOnMobileSite",
    staticStyle: {
      "position": "absolute",
      "top": "30px",
      "left": "50%",
      "margin-left": "-90px",
      "z-index": "102"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDashboard.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "angle double up icon"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("Back to the Home screen")]), _vm._v(" "), (_vm.$parent.worldStore.notifications) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$parent.worldStore.notifications.length > 0),
      expression: "$parent.worldStore.notifications.length>0"
    }],
    staticClass: "floating ui violet mini label",
    staticStyle: {
      "border-radius": "9px"
    },
    attrs: {
      "data-tooltip": "Recent Notifications",
      "data-inverted": "",
      "data-position": "right center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.worldStore.notifications.length))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dashboardIsFolded),
      expression: "dashboardIsFolded"
    }],
    staticClass: "hideOnMobileSite",
    attrs: {
      "id": "detailsSelector"
    }
  }, [(_vm.$parent.onboarding.viewtype) ? _c('div', {
    staticClass: "onboarding ui left pointing large yellow label",
    staticStyle: {
      "position": "absolute",
      "left": "475px",
      "z-index": "111"
    },
    attrs: {
      "data-onboarding": "viewtype"
    }
  }, [_vm._v("\n      Sort by Products or by Issues - will come really handy!"), _c('br'), _vm._v(" "), _c('small', {
    staticStyle: {
      "float": "left",
      "margin-top": "5px"
    }
  }, [_vm._v("Click on [ISSUES] to dismiss this note")])]) : _vm._e(), _vm._v("\n\n    View  \n    "), _c('a', {
    class: 'ui circular big black icon button ' + (_vm.detSel == 'pr' || _vm.detSel == 'pr2' ? 'active' : 'basic'),
    on: {
      "click": [function($event) {
        $event.preventDefault();
        return _vm.switchToProdView()
      }, function($event) {
        if (!$event.shiftKey) { return null; }
        $event.preventDefault();
        return _vm.setDetailView('pr2')
      }]
    }
  }, [_c('i', {
    staticClass: "cubes icon"
  }), _vm._v("   Products\n    ")]), _vm._v("\n     -or-  \n    "), _c('a', {
    class: 'ui circular big black icon button ' + (_vm.detSel == 'wd' || _vm.detSel == 'wc' ? 'active' : 'basic'),
    on: {
      "click": [function($event) {
        $event.preventDefault();
        return _vm.setDetailView('wd')
      }, function($event) {
        if (!$event.shiftKey) { return null; }
        $event.preventDefault();
        return _vm.setDetailView('wc')
      }]
    }
  }, [_c('i', {
    staticClass: "list layout icon"
  }), _vm._v("   Issues\n    ")]), _vm._v("\n     -or-  \n    "), _c('a', {
    class: 'ui circular big black icon button ' + (_vm.detSel == 'inv' ? 'active' : 'basic'),
    staticStyle: {
      "position": "relative"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDetailView('inv')
      }
    }
  }, [_c('i', {
    staticClass: "warehouse icon"
  }), _vm._v("     Stock\n      "), _c('div', {
    staticClass: "floating ui inverted  red label",
    staticStyle: {
      "top": "4px",
      "padding": "2px 4px",
      "border-radius": "8px"
    }
  }, [_vm._v("new")])]), _vm._v("\n                   \n                   \n    "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "margin-left": "-10px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filterShowSASelector),
      expression: "filterShowSASelector"
    }],
    staticClass: "ui multiple dropdown filtersa",
    staticStyle: {
      "padding": "0 20px 0 0"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "filter"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "filter icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "margin-left": "0"
    }
  }, [_vm._v("Filter S.Accounts")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "margin": "3px"
    }
  }, [_vm._v("\n          Seller Accounts\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "scrolling menu"
  }, _vm._l((_vm.$parent.worldStore.sellerAccounts), function(sa) {
    return _c('div', {
      staticClass: "item",
      attrs: {
        "data-value": sa.sellerId
      }
    }, [_c('i', {
      class: (sa.region == 'NA' ? 'olive' : 'teal') + ' circle compact icon'
    }), _vm._v(_vm._s(sa.accountNickName) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filterUserCountries.length > 1),
      expression: "filterUserCountries.length>1"
    }],
    staticClass: "ui multiple dropdown filterc",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "filter"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "filter icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "margin-left": "0"
    }
  }, [_vm._v("Filter Marketplaces")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "margin": "3px"
    }
  }, [_vm._v("\n          Marketplaces\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "scrolling menu"
  }, _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      class: c == 's' ? 'divider' : 'item',
      attrs: {
        "data-value": c
      }
    }, [(c != 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag'
    }) : _vm._e(), _vm._v(_vm._s(c != 's' ? c : '') + "\n          ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "ui checkbox labelCursorFix",
    style: ('display:none;    margin-left:180px; margin-top:10px;' + (_vm.detSel === 'pr' ? 'opacity:0;' : ''))
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortListByImportance),
      expression: "sortListByImportance"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "name": "sortListByImportance",
      "id": "sortListByImportance"
    },
    domProps: {
      "checked": Array.isArray(_vm.sortListByImportance) ? _vm._i(_vm.sortListByImportance, null) > -1 : (_vm.sortListByImportance)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sortListByImportance,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sortListByImportance = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sortListByImportance = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sortListByImportance = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "labelCursorFix",
    attrs: {
      "for": "sortListByImportance"
    }
  }, [_vm._v("Show Problems on top")])]), _vm._v(" "), (_vm.detSel == 'pr' || _vm.detSel == 'pr2') ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "55px",
      "left": "46%",
      "transform": "translateX(41vw)",
      "width": "100px",
      "height": "40px"
    }
  }, [_c('i', {
    staticClass: "big icon th  ",
    style: ('cursor:pointer; color:' + (_vm.detSel == 'pr' ? 'yellow;' : '#eee')),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDetailView('pr')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "big icon bars",
    style: ('cursor:pointer; color:' + (_vm.detSel == 'pr2' ? 'yellow;' : '#eee')),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDetailView('pr2')
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: {
      opn: _vm.dashboardIsFolded
    },
    attrs: {
      "id": "mainContainer"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.detSel == 'wd' || _vm.detSel == 'wc') ? _c('div', {
    staticClass: "ui blue message onlyOnMobileSite",
    staticStyle: {
      "cursor": "pointer",
      "margin": "20px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDetailView('pr')
      }
    }
  }, [_vm._v("\n      On SentryKit Mobile only the "), _c('strong', [_vm._v("Product View")]), _vm._v(" is available."), _c('br'), _c('br'), _vm._v("\n      Tap this message to switch to that.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 402 || _vm.$root.paymentStatus == 403) ? _c('div', {
    staticClass: "ui red message onlyOnMobileSite",
    staticStyle: {
      "margin": "20px"
    }
  }, [_vm._v("\n      Your SentryKit account is unfortunately suspended. We couldn't charge you for the current month."), _c('br'), _c('br'), _vm._v("\n      Please update your payment method in "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(".\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.detSel == 'pr' || _vm.detSel == 'pr2') ? _c('div', {
    key: "2",
    staticClass: "ui fluid container",
    staticStyle: {
      "padding": "0 4vh"
    },
    attrs: {
      "id": "prodCont"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.detSel == 'pr') ? _c('ProductCard', {
    ref: "productCard"
  }) : _vm._e(), _vm._v(" "), (_vm.detSel == 'pr2') ? _c('ProductList', {
    ref: "productList"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.detSel == 'pr' || _vm.detSel == 'pr2') ? _c('div', {
    staticClass: "ui center aligned segment",
    staticStyle: {
      "margin-top": "20px",
      "background-color": "#f8f8f8",
      "border": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.getCurrentPage() === 0
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.getTotalPages())), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.getCurrentPage() === _vm.getPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToPage(_vm.getPageNumber(page))
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getPageNumber(page) + 1) + "\n          ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.getCurrentPage() >= (_vm.getTotalPages() - 1)
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n          Showing page " + _vm._s(_vm.getCurrentPage() + 1) + " of " + _vm._s(_vm.getTotalPages()) + "\n          (" + _vm._s(_vm.getTotalItems()) + " total products)\n        ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.detSel == 'inv') ? _c('div', {
    key: "3",
    staticClass: "ui fluid container",
    staticStyle: {
      "padding": "0 7vw"
    },
    attrs: {
      "id": "prodCont"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeLeft",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('InventoryList'), _vm._v(" "), (_vm.$parent.stocksTotalPages > 1) ? _c('div', {
    staticClass: "ui center aligned segment",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.$parent.stocksCurrentPage === 0
    },
    on: {
      "click": _vm.prevStocksPage
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.$parent.stocksTotalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.$parent.stocksCurrentPage === _vm.getPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.loadStocksPage(_vm.getPageNumber(page))
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.getPageNumber(page) + 1) + "\n            ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.$parent.stocksCurrentPage >= _vm.$parent.stocksTotalPages - 1
    },
    on: {
      "click": _vm.nextStocksPage
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n            Showing page " + _vm._s(_vm.$parent.stocksCurrentPage + 1) + " of " + _vm._s(_vm.$parent.stocksTotalPages) + "\n            (" + _vm._s(_vm.$parent.stocksTotalItems) + " total items)\n          ")])]) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.detSel == 'wd' || _vm.detSel == 'wc') ? _c('div', {
    key: "1",
    class: _vm.detSel == 'wd' ? 'wide' : '',
    attrs: {
      "id": "wdCont"
    }
  }, [_c('transition', {
    attrs: {
      "name": "componentFade",
      "appear": ""
    }
  }, [_c('WatchdogMenu', {
    attrs: {
      "wdNewErrorCounts": _vm.wdNewErrorCounts,
      "wdMenuUpdateTrigger": _vm.wdMenuUpdateTrigger
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui stackable cards hideOnMobileSite",
    attrs: {
      "id": "context"
    }
  }, _vm._l((_vm.wdListSorted), function(i, index) {
    return _c('Watchdog', {
      key: i,
      attrs: {
        "wdtype": i,
        "wd": _vm.$parent.worldStore.watchDogs[i],
        "detSel": _vm.detSel,
        "scrollIntoView": true,
        "nth": index,
        "suppressed-watchdogs": _vm.suppressedWatchdogs
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detSel == 'wd' || _vm.detSel == 'wc') ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "height": "100vh",
      "width": "100vw",
      "background-color": "rgba(0,0,0,.6)",
      "pointer-events": "none",
      "z-index": "11",
      "display": "none"
    },
    attrs: {
      "id": "darkbackgr"
    }
  }) : _vm._e()]), _vm._v(" "), _c('ProductDetails', {
    ref: "productDetails"
  }), _vm._v(" "), _c('LoadingSpinner', {
    class: {
      'side': _vm.dashboardIsFolded
    }
  }), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "ui active inverted loader"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white",
      "margin-top": "60px",
      "font-size": "16px"
    }
  }, [_vm._v("Loading data...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "30px 0px 0px 75px"
    }
  }, [_c('div', {
    staticClass: "ui segment",
    staticStyle: {
      "background": "none",
      "border": "none",
      "-webkit-box-shadow": "none"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "250px",
      "margin": "-15px"
    },
    attrs: {
      "src": require("./assets/skwhite_noslogan.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted black segment onlyOnMobileSite",
    staticStyle: {
      "margin-bottom": "20px",
      "margin-left": "10px",
      "width": "140px",
      "z-index": "101"
    }
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "color": "#f2711c"
    }
  }, [_vm._v("Sentry")]), _c('span', {
    staticStyle: {
      "color": "#3bd"
    }
  }, [_vm._v("Kit")]), _vm._v(" "), _c('span', {}, [_vm._v("Mobile")])]), _vm._v(" "), _c('small')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bdf5a1f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/HomePage.vue
// module id = 810
// module chunks = 2